import { SelectorPills } from '$tablet-app/src/app/components/SelectorPills/SelectorPills';
import { SelectorPillItem } from '$tablet-app/src/app/components/SelectorPills/SelectorPills.props';
import { colors } from '@akin-home/theme';
import React from 'react';

export const formOptions: SelectorPillItem[] = [
  {
    id: '1',
    label: 'Event',
    color: colors.secondary[700],
    backgroundColor: colors.lightblue,
  },
  {
    id: '3',
    label: 'Alert',
    color: colors.text.green,
    backgroundColor: colors.text.green_background,
  },
  {
    id: '4',
    label: 'Alarm',
    color: colors.text.yellow,
    backgroundColor: colors.text.yellow_background,
  },
];

interface Props {
  value: string;
  onChange: (type: any) => void;
}

const CalendarItemTypeSelector = (props: Props) => (
  <SelectorPills
    items={formOptions}
    value={props.value}
    onChange={props.onChange}
  />
);

export default CalendarItemTypeSelector;
